import * as React from 'react'
import { displayCase } from '@/features/patients/utils/clientDisplay'

export interface ClientMetaRow {
  label: string
  value: React.ReactNode
}

function isEmpty(value: React.ReactNode): boolean {
  return (
    value === null ||
    value === undefined ||
    value === false ||
    (typeof value === 'string' && value.trim().length === 0)
  )
}

/**
 * Label/value rows in a bordered list.
 *
 * Empty values render an em dash rather than dropping the row: a blank housing
 * status or ethnicity is itself worth seeing, and a list that silently omits
 * unknown fields reads as though the record is complete.
 */
export function ClientMetaList({ rows }: { rows: ClientMetaRow[] }) {
  return (
    <dl className="divide-y rounded-md border px-3">
      {rows.map((row) => (
        <div
          key={row.label}
          className="flex justify-between gap-4 py-1.5 text-sm">
          <dt className="text-muted-foreground shrink-0">{row.label}</dt>
          <dd className="min-w-0 text-right break-words">
            {isEmpty(row.value) ? (
              <span className="text-neutral-hover-border">—</span>
            ) : typeof row.value === 'string' ? (
              // Source systems often send these in all caps.
              displayCase(row.value)
            ) : (
              row.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  )
}
